
import { defineComponent, PropType } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import { GatewayRoleT } from '@/core/types/gateway.types'

export default defineComponent({
    components: {
        modal: Modal,
    },
    props: {
        role: {
            type: Object as PropType<GatewayRoleT>,
            default: null,
        },
    },
    emits: ['close'],
    setup(_, { emit }) {
        const emitClose = () => {
            emit('close')
        }

        return { emitClose }
    },
})
